import EventSelector from "@main/events/components/EventSelector";

const filterUIConfig = {
  uiScheme: {
    classNames: "filters-container",
    search: {
      "ui:options": {
        label: false, // Oculta el título del campo
        placeholder: "Buscar...",
      },
    },
  },
};
const getFilterUIConfig: any = (type: string) => {
  return filterUIConfig;
};
export default getFilterUIConfig;
